/**
 * Fjernhjelp (A11, 1031): «Gå inn som support» fra Control Room og «Gå ut» fra båndet øverst.
 * Begge endrer medlemskapene i `/v1/me`, så hele bufferen feies (samme som å bytte organisasjon).
 */
import {
  supportSessionSchema,
  type EnterSupportRequest,
  type SupportSession,
} from '@tvitvi/shared';
import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { apiRequest } from '@/api/client';
import { qk } from '@/api/query-keys';

export function useEnterSupport(
  organizationId: string,
): UseMutationResult<SupportSession, unknown, EnterSupportRequest> {
  return useMutation({
    mutationFn: (body: EnterSupportRequest) =>
      apiRequest({
        path: `/platform/organizations/${organizationId}/support`,
        method: 'POST',
        body,
        schema: supportSessionSchema,
        sendOrganizationHeader: false,
      }),
    meta: { invalidates: [qk.me()] },
  });
}

export function useLeaveSupport(): UseMutationResult<void, unknown, string> {
  return useMutation({
    mutationFn: async (organizationId: string) => {
      await apiRequest({
        path: `/platform/organizations/${organizationId}/support`,
        method: 'DELETE',
        sendOrganizationHeader: false,
      });
    },
    meta: { invalidates: [qk.all] },
  });
}
